import { useCallback, useMemo } from "react";
import { useHistory } from "react-router-dom";

import moment from "moment";

import { TaskDocument } from "../../task/task.model";
import { useComplaintTasks } from "../../workflow/follow-up/appointment/TaskProvider";
import { AwaitCustomerResponseTab } from "./AwaitCustomerResponseTab";

export const IntegratedAwaitCustomerResponseTab = () => {
    const history = useHistory();
    const goToTask = useCallback((task: TaskDocument) => {
        history.push(`/complaint/await-customer-response/${task.id}`);
    }, [history]);

    const now = moment().toISOString(true);

    const tasks = useComplaintTasks();

    const relevantTasks = useMemo(() => tasks.filter(task => task.complaint.status === "awaiting customer response to proposal"), [tasks]);
    const currentTasks = useMemo(() => relevantTasks.filter(task => task.performAfterDate <= now), [relevantTasks, now]);
    const futureTasks = useMemo(() => relevantTasks.filter(task => task.performAfterDate > now), [relevantTasks, now]);

    return (
        <AwaitCustomerResponseTab
            currentTasks={currentTasks}
            futureTasks={futureTasks}
            goToTask={goToTask}
        />
    );
};
